import { CSV_COLUMN_MAPPING } from "../../../constants/salesOverviewConstants";
import { Typography } from "antd";

export const getTableColumns = () =>
  CSV_COLUMN_MAPPING.map((key) => ({
    title: key,
    dataIndex: key,
    key: key,
    ellipsis: true,
    minWidth: 150,
    render: (value: string) => (
      <Typography.Text style={{ textWrap: "nowrap" }}>{value}</Typography.Text>
    ),
  }));
